import React from "react";

const FRETS = [120, 168, 212, 252, 288, 321, 351, 378, 403, 426, 447, 466];
const STRING_Y = [131, 136, 141, 146, 151, 156];
const PARTS = [
  { label: "Headstock", x: 70, y: 160, tx: 20, ty: 240 },
  { label: "Tuning pegs", x: 64, y: 112, tx: 20, ty: 40 },
  { label: "Nut", x: 116, y: 128, tx: 150, ty: 72 },
  { label: "Frets", x: 252, y: 126, tx: 240, ty: 72 },
  { label: "Neck / fretboard", x: 345, y: 160, tx: 280, ty: 238 },
  { label: "Strings", x: 430, y: 141, tx: 400, ty: 72 },
  { label: "Sound hole", x: 600, y: 143, tx: 555, ty: 40 },
  { label: "Bridge", x: 712, y: 160, tx: 700, ty: 262 },
  { label: "Body", x: 770, y: 90, tx: 790, ty: 40 },
];

// A labelled side-on acoustic guitar: headstock on the left, body on the right.
export const GuitarDiagram = ({ testId = "guitar-diagram" }) => (
  <figure className="mt-5 rounded-2xl border border-border bg-card p-4" data-testid={testId}>
    <svg viewBox="0 0 880 280" className="w-full" role="img" aria-label="Labelled guitar: headstock, tuning pegs, nut, frets, neck and fretboard, strings, sound hole, bridge and body">
      <path d="M20 118 L112 124 L112 162 L20 168 Z" fill="#7C4A21" />
      {[0, 1, 2].map((k) => <g key={k}><circle cx={38 + k * 26} cy={112} r="7" fill="#D6D3D1" /><circle cx={38 + k * 26} cy={174} r="7" fill="#D6D3D1" /></g>)}
      <ellipse cx="590" cy="143" rx="110" ry="92" fill="#C8873E" />
      <ellipse cx="740" cy="143" rx="125" ry="112" fill="#C8873E" />
      <rect x="112" y="124" width="420" height="38" fill="#3F2A1C" />
      <rect x="112" y="122" width="7" height="42" fill="#F5F5F4" />
      {FRETS.map((x) => <line key={x} x1={x} y1={124} x2={x} y2={162} stroke="#A8A29E" strokeWidth="2" />)}
      {[270, 336, 390, 437].map((x) => <circle key={x} cx={x} cy={143} r="4" fill="#E7E5E4" />)}
      <circle cx="600" cy="143" r="42" fill="#1C1209" />
      <rect x="700" y="120" width="26" height="46" rx="4" fill="#3F2A1C" />
      {STRING_Y.map((y) => <line key={y} x1={30} y1={y} x2={713} y2={y} stroke="#F5F5F4" strokeWidth="1.1" />)}
      {PARTS.map((p) => (
        <g key={p.label}>
          <line x1={p.x} y1={p.y} x2={p.tx + 20} y2={p.ty + (p.ty < p.y ? 8 : -14)} stroke="#F59E0B" strokeWidth="1.5" />
          <circle cx={p.x} cy={p.y} r="3.5" fill="#F59E0B" />
          <text x={p.tx} y={p.ty} fontSize="17" fontWeight="700" fill="currentColor" data-testid={`${testId}-label-${p.label.split(" ")[0].toLowerCase()}`}>{p.label}</text>
        </g>
      ))}
    </svg>
    <figcaption className="mt-2 text-center text-xs text-muted-foreground">The parts of a guitar. The strings run from the tuning pegs on the headstock, over the nut and the frets, to the bridge on the body.</figcaption>
  </figure>
);
